import { invariant } from '@mimir/common/util/invariant';
import type { SimpleDialogRequest } from './simpleDialogRequest';
import type { BaseDialogProps } from './types';
import EventBus, { EVENTS } from '../eventBus';


/**
 * Show a simple dialog with a confirm and cancel button, the text can be configured
 * through dialogProps.
 *
 * @param dialogProps The props to configure the dialog
 * @param actionFn The synchronous callback to call when the user confirms the dialog, if any.
 */
export function showSimpleDialog(
  dialogProps: BaseDialogProps,
  actionFn?: () => void,
  secondaryActionFn?: () => void,
  cancelFn?: () => void,
) {
  const req: SimpleDialogRequest = {
    dialogProps: {
      closeOnActionClick: true,
      ...dialogProps,
    },
    callback: (response) => {
      if (response === 'ok') {
        if (actionFn) {
          actionFn();
        }
      } else if (response === 'secondaryOk') {
        invariant(secondaryActionFn, 'Expected function to call on secondary action');
        secondaryActionFn();
      } else if (response === 'cancel') {
        if (cancelFn) {
          cancelFn();
        }
      }
    }
  };
  showSimpleDialogFromRequest(req);
}

export function showSimpleDialogFromRequest(req: SimpleDialogRequest) {
  EventBus.emit(EVENTS.SHOW_DIALOG, {
    type: 'simple',
    req,
  });
}
